import Cookies from 'js-cookie'
import moment from 'moment'

import { getErrorMessage } from '@/app/store/api'

import { ERROR_AUTH_SIGNUP, SIGNUP_ERROR_MAP } from './definitions'

export const setToken = (authToken: string, validUntil: string) => {
  const expiryDate = validUntil ? moment(validUntil).toDate() : moment().add('7', 'day').toDate()
  Cookies.set('authToken', authToken, { expires: expiryDate, sameSite: 'strict', secure: true })
  Cookies.set('authTokenExpiresAt', expiryDate.toISOString(), { expires: expiryDate, sameSite: 'strict', secure: true })
}

/**
 * return true if the token is 1 day from expiring
 */
export const isTokenAboutToExpire = () => {
  const expiryDate = Cookies.get('authTokenExpiresAt')
  if (!expiryDate) {
    return true
  }
  return moment(expiryDate).subtract(1, 'day').diff(moment()) <= 0
}

export const getSignupErrorMessage = (error: unknown) => {
  const errorMessageResp = getErrorMessage(error, '')

  return SIGNUP_ERROR_MAP[errorMessageResp] || ERROR_AUTH_SIGNUP
}
